"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedDashboard = void 0;
/**
 * The metadata object associated with how a dashboard has been/will be shared.
 */
class SharedDashboard {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return SharedDashboard.attributeTypeMap;
    }
}
exports.SharedDashboard = SharedDashboard;
/**
 * @ignore
 */
SharedDashboard.attributeTypeMap = {
    author: {
        baseName: "author",
        type: "SharedDashboardAuthor",
    },
    createdAt: {
        baseName: "created_at",
        type: "Date",
        format: "date-time",
    },
    dashboardId: {
        baseName: "dashboard_id",
        type: "string",
        required: true,
    },
    dashboardType: {
        baseName: "dashboard_type",
        type: "DashboardType",
        required: true,
    },
    globalTime: {
        baseName: "global_time",
        type: "DashboardGlobalTime",
    },
    globalTimeSelectableEnabled: {
        baseName: "global_time_selectable_enabled",
        type: "boolean",
    },
    publicUrl: {
        baseName: "public_url",
        type: "string",
    },
    selectableTemplateVars: {
        baseName: "selectable_template_vars",
        type: "Array<SelectableTemplateVariableItems>",
    },
    shareList: {
        baseName: "share_list",
        type: "Array<string>",
        format: "email",
    },
    shareType: {
        baseName: "share_type",
        type: "DashboardShareType",
    },
    token: {
        baseName: "token",
        type: "string",
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=SharedDashboard.js.map